module.exports = __webpack_public_path__ + "img/221.problem_left_elevator.6e4cc166.svg";